import { render } from "./month-year-picker.vue?vue&type=template&id=2e0cd538&ts=true"
import script from "./month-year-picker.vue?vue&type=script&lang=ts"
export * from "./month-year-picker.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__